import {
  EVENT_DELETE_MESSAGES,
  EVENT_EDIT_MESSAGE,
  EVENT_SEND_MESSAGES,
  EventDeleteMessagesPayload,
  EventEditMessagePayload,
  EventSendMessagesPayload,
} from '@weblite/ts-action/message'
import { serverSub } from '$func/subscription'
import { handleNotifAudio } from '$logic/notif-audio'
import {
  handleDeleteMessagesNotification,
  handleEditMessageNotification,
} from '$logic/push/service'
import * as roomService from '$logic/room'
import { handleSeenStatusOnMessageChange } from '$logic/users'
import { messagesStorage } from '$logic/message/storage'
import {
  deleteMessagesFromClient,
  getMessageByIid,
  handleNewMessage,
  saveEditMessage,
  saveMessages,
} from './service'

serverSub.subscribe(
  EVENT_SEND_MESSAGES,
  async ({ messages }: EventSendMessagesPayload) => {
    handleNewMessage(messages, true)
    await saveMessages(messages)
    handleNotifAudio(messages)
    messages.forEach(handleSeenStatusOnMessageChange)
  },
)

serverSub.subscribe(
  EVENT_EDIT_MESSAGE,
  async (patch: EventEditMessagePayload) => {
    await saveEditMessage([patch])
    handleEditMessageNotification(patch)
    handleSeenStatusOnMessageChange(
      await getMessageByIid(patch.roomId, patch.iid),
    )
  },
)

serverSub.subscribe(
  EVENT_DELETE_MESSAGES,
  async (patch: EventDeleteMessagesPayload) => {
    await deleteMessagesFromClient(patch)
    await roomService.handleDeletedMessages(patch.roomId, patch.iids)
    handleDeleteMessagesNotification(patch)

    const messages = await messagesStorage.findByIids(patch.roomId, patch.iids)
    messages.forEach(handleSeenStatusOnMessageChange)
  },
)
